import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL || ''
});

instance.interceptors.request.use(config => {
    const token = localStorage.getItem('dealerToken');
    if (token) {
        config.headers['X-SpeedyRC-Dealer-Token'] = token;
    }
    return config;
});

// axios rejects on any non-2xx status before our own success-check code ever runs, so
// error.message defaults to a generic "Request failed with status code X" -- surface the
// actual server-provided message (response.data.error) instead, wherever one exists.
instance.interceptors.response.use(
    response => response,
    error => {
        const serverMessage = error.response && error.response.data && error.response.data.error;
        if (serverMessage) {
            error.message = serverMessage;
        }
        return Promise.reject(error);
    }
);

export default instance;
